import { getItemFromLocalStorage, setItemFromLocalStorage } from 'reactApp/appHelpers/localstorageHelpers';

const STORAGE_ITEM_NAME = 'B2BAllDocumentsAccessRequestSent';

export const getAllDocumentsAccessRequestTimer = () => getItemFromLocalStorage(STORAGE_ITEM_NAME);

export const setAllDocumentsAccessRequestTimer = (value: number) => setItemFromLocalStorage(STORAGE_ITEM_NAME, value);
